<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    ประวัติการเติมเกม
                </div>


                <div class="row search-section">
                    <div class="col-sm-1 col-search">



                    </div>

                    <div class="col-sm-2 col-search">
                        <input type="text" class="search-textbox" v-model="key"
                            placeholder="ค้นหาด้วยชื่อผู้ใช้ ชื่อเกม uid" style="width:100%;margin-top:5px">
                    </div>

                     <div class="col-sm-1 col-search">
                        <select v-model="status" class="form-control">
                            <option value="-1">ทั้งหมด</option>
                            <option value="0">รอดำเนินการ</option>
                            <option value="1">สำเร็จ</option>
                            <option value="2">ล้มเหลว</option>
                        </select>
                    </div>

                    <div class="col-sm-4 col-search" style="display: flex;">
                        <date-picker v-model="start_date" format="DD-MM-YYYY" placeholder="วันเริ่มต้น" />
                        <div style="width: 30px;">-</div>
                        <date-picker v-model="end_date" format="DD-MM-YYYY" placeholder="วันสิ้นสุด" />
                    </div>

                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching"
                            @click="search(1)">
                            <i class="material-icons">search</i>
                            <span>ค้นหา</span>
                        </button>
                    </div>
                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-grey waves-effect btn-search" :disabled="searching"
                            @click="reset()">
                            <i class="material-icons">refresh</i>
                            <span>Reset</span>
                        </button>
                    </div>

                </div>

                <div class="body table-responsive" style="width:100%">
                    <div class="row">
                        <div class="col-sm-6" style="text-align: left;">
                            <div class="p-title">แสดงรายการระหว่าง วันที่ {{ start_date_text }} - {{ end_date_text }}
                            </div>
                        </div>
                        <div class="col-sm-5"> </div>
                        <div class="col-sm-1" style="text-align: right;">
                            <img src="static/images/excel.png" style="position: absolute;right: 10px;cursor: pointer;"
                                @click="download()" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12" style="text-align: left;">
                            <b>จำนวนสั่งซื้อทั้งหมด:</b> {{ total | comma }} ครั้ง
                        </div>
                    </div>
                     <div class="row">
                        <div class="col-sm-12" style="text-align: left;">
                            <b>จำนวนชำระเงินทั้งหมด:</b> {{ count_all_wepay_price | comma }} ครั้ง
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12" style="text-align: left;">
                            <b> ราคารวมทั้งหมด:</b> {{ total_amount | comma2 }} บาท
                        </div>
                    </div>
                     <div class="row">
                        <div class="col-sm-12" style="text-align: left;">
                            <b> กำไรทั้งหมด:</b> {{ total_profit | comma2 }} บาท
                        </div>
                    </div>

                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>


                        <table class="table table-bordered">
                            <thead>

                                <tr>
                                    <th class="fn-th" style="width: 80px;">No.</th>
                                    <th class="fn-th">ชื่อสมาชิก</th>
                                    <th class="fn-th">ชื่อเกม</th>
                                    <th class="fn-th">uid</th>
                                    <th class="fn-th">แพคเกจ</th>
                                    <th class="fn-th" style="width:118px">จำนวนเงิน</th>
                                    <th class="fn-th" style="width:118px">จำนวนครั้ง</th>
                                    <th class="fn-th">กำไร</th>
                                    <th class="fn-th" style="width: 200px;">สถานะ</th>
                                    <th class="fn-th" style="width: 200px;">Wepay</th>
                                    <th class="fn-th">วันที่</th>
                                    <th class="fn-th">หมายเหตุ</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="'p-' + item.id"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                    <td v-html="((page - 1) * perpage) + index + 1"></td>



                                    <td style="text-align: center;">
                                        <span>{{ item.username }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.game_name }}</span>
                                    </td>
                                     <td style="text-align: center;">
                                        <span>{{ item.uid }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.package_name }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.amount }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.times }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.profit }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span style='color: orange;' v-if="item.status == 0">รอดำเนินการ</span> 
                                        <span style='color: green;' v-if="item.status == 1">สำเร็จ</span>
                                        <span style='color: red;' v-if="item.status > 1">ล้มเหลว{{ item.error_msg ? ' - ' + item.error_msg : '' }}</span>
                                        
                                    </td>
                                    
                                    <td style="text-align: center;">
                                        <span>{{ item.sms }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.created_at | date }} </span>
                                    </td>
                                    <td style="text-align: center;">
                                        {{ item.wepay_prices }}
                                    </td>

                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <Paginate v-model=page :page-count=pages :page-range="5" :click-handler="search" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'fn-pagination'" />


                </div>
            </div>
        </div>

    </section>
</template>

<script>
import TopupGameService from '../../service/TopupGameService'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import Paginate from 'vuejs-paginate'
import alertBox from '../../classes/alertBox'

export default {
    name: "TopupGame",
    components: {
        DatePicker,
        Paginate
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            date: localStorage.getItem('date'),
            page: 1,
            perpage: 50,
            total: 0,
            total_amount: 0,
            total_profit: 0,
            count_all_wepay_price: 0,
            pages: 0,
            items: [],
            key: "",
            file: null,
            status: -1,
            searching: false,
            loading: false,
            start_date: null,
            start_date_text: "",
            end_date_text: "",
            end_date: null,
            search_params: {}
        }
    },
    async created() {
        this.start_date = new Date(this.date)
        this.end_date = new Date(this.date)

        this.search(1)
    },
    mounted() {

    },
    watch: {
        start_date(val) {
            this.end_date = val
        }
    },
    methods: {

        async search(p = 0) {
             if (p > 0) {
                this.page = p
            }
            this.loading = true
            let start_date = moment(this.start_date).format('YYYY-MM-DD')
            let end_date = moment(this.end_date).format('YYYY-MM-DD')
            this.start_date_text = moment(this.start_date).format('DD/MM/YYYY')
            this.end_date_text = moment(this.end_date).format('DD/MM/YYYY')

            let response = await TopupGameService.search(this.key, this.page, this.perpage, start_date, end_date,this.status)
            console.log(response)
            if (response.status) {
                let { page, perpage, total, pages, data, total_amount, total_profit, count_wepay_price,count_wepay_price2,count_wepay_price3,count_wepay_price4 } = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages)
                this.items = data.map((item => {
                    return {
                        ...item,
                        times: item.wepay_prices.split(',').filter(x => x > 0).length,
                        wepay_prices: item.wepay_prices.split(',').map(x => Number(x.split('.')[0])).filter(x => x > 0).join(','),
                    }
                }))
                this.total_amount = total_amount
                this.total_profit = total_profit
                this.count_all_wepay_price = Number(count_wepay_price) + Number(count_wepay_price2) + Number(count_wepay_price3) + Number(count_wepay_price4)
            }
            this.loading = false
        },
        reset() {
            this.key = ""
            this.status = -1
            this.start_date = new Date(this.date)
            this.end_date = new Date(this.date)
            this.search(1)
        },
        download(){
            let start_date = moment(this.start_date).format('YYYY-MM-DD')
            let end_date = moment(this.end_date).format('YYYY-MM-DD')
            let url = `${process.env.API2}/export/topup/game`
            let fileName = 'topupgame_' + moment().format('YYYYMMDD_HHmmss') +'.xlsx'
           
            let request = new XMLHttpRequest();
            request.onload = function(e) {
                if (this.status === 200) {
                    
                        let blob = this.response;
                        if(window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveBlob(blob, fileName);
                            
                        }
                        else{
                            let downloadLink = window.document.createElement('a');
                            let contentTypeHeader = request.getResponseHeader("Content-Type");
                            downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: contentTypeHeader }));
                            downloadLink.download = fileName;
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                            
                        }
                    
                }
                else{
                    alertBox.error("Error ,Can not download")
                    
                }
               
            };
            
            request.open('POST', url);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            request.withCredentials = true;
            request.responseType = 'blob';
            request.send(`searchKey=${this.key}&startDate=${start_date}&endDate=${end_date}`);
        },

    },
    filters: {
        comma(value) {
            return helper.WithComma(value)
        },
        comma2(value) {
            return helper.WithComma(value, 2)
        },
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/Manage/TopupGame.vue